import axios from "axios";
import { translator } from "./constants/actionTypes";
import { localStorageHelper } from "./utils/storageHelper";
import { authTypes } from "./constants/componentConstants";

const urlPath = window.location.href;
let tenantId = "";
let authToken = "";

const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use(function (config) {
  if (localStorageHelper.get("wsm_auth_type")) {
    tenantId =
      localStorageHelper.get("wsm_auth_type") === authTypes.SAML
        ? localStorageHelper.get("wsmLocalTenantId")
        : localStorageHelper.get("wsmTenantId");

    //Auh token based on auth type
    authToken =
      localStorageHelper.get("wsm_auth_type") === authTypes.azuerAD
        ? localStorageHelper.get("wsmAuthToken")
        : localStorageHelper.get("wsmAccessToken");
  } else if (localStorageHelper.get("auth_type")) {
    tenantId =
      localStorageHelper.get("auth_type") === authTypes.SAML || localStorageHelper.get("auth_type") === authTypes.localUser
        ? localStorageHelper.get("localTenantId")
        : localStorageHelper.get("tenantId");

    //Auh token based on auth type
    authToken =
      localStorageHelper.get("auth_type") === authTypes.azuerAD
        ? localStorageHelper.get("authToken")
        : localStorageHelper.get("accessToken");
  }

  config.headers.tenant = tenantId;
  config.headers.Authorization = authToken;
  config.headers.accessToken = `Bearer ${localStorageHelper.get("accessToken") || localStorageHelper.get("wsmAccessToken")}`;
  config.headers.role = localStorageHelper.get("role");
  config.headers.authtype = localStorageHelper.get("auth_type") || localStorageHelper.get("wsm_auth_type");
  return config;
});

if (urlPath.includes(translator.baseURL)) {
  axiosInstance.defaults.baseURL = translator.baseURL;
} else if (urlPath.includes(translator.localhost3000)) {
  axiosInstance.defaults.baseURL = translator.baseURL;
} else if (urlPath.includes(translator.localhost3001)) {
  axiosInstance.defaults.baseURL = translator.baseURL;
} else if (urlPath.includes(translator.qaBaseURL)) {
  axiosInstance.defaults.baseURL = translator.qaBaseURL;
} else if (urlPath.includes(translator.prefBaseURL)) {
  axiosInstance.defaults.baseURL = translator.prefBaseURL;
} else if (urlPath.includes(translator.stageBaseURL)) {
  axiosInstance.defaults.baseURL = translator.stageBaseURL;
} else if (urlPath.includes(translator.prodBaseURL)) {
  axiosInstance.defaults.baseURL = translator.prodBaseURL;
} else if (urlPath.includes(translator.uatBaseURL)) {
  axiosInstance.defaults.baseURL = translator.uatBaseURL;
} else if (urlPath.includes(translator.hotfixBaseURL)) {
  axiosInstance.defaults.baseURL = translator.hotfixBaseURL;
}

export default axiosInstance;
